import { render, staticRenderFns } from "./SettingsEngineTcType.vue?vue&type=template&id=b397defe&scoped=true&"
import script from "./SettingsEngineTcType.vue?vue&type=script&lang=js&"
export * from "./SettingsEngineTcType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b397defe",
  null
  
)

export default component.exports